import { styled as o } from "styled-components";
import { LoadMoreButton as t } from "../../../components/LoadMoreButton/index.js";
const d = o(t)`
  padding: 24px 0;
`;
export {
  d as NotificationLoadMoreButton
};
